import { render, staticRenderFns } from "./cardList.vue?vue&type=template&id=8f0aacfa&scoped=true"
import script from "./cardList.vue?vue&type=script&lang=ts"
export * from "./cardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0aacfa",
  null
  
)

export default component.exports